module.exports = __webpack_public_path__ + "static/media/ready_to_serve.79897d88.svg";